import api from "./index";

export async function createUser(body) {
  return api.post(`/people`, body);
}

export async function updateUser(id, body) {
  return api.put(`/people/${id}`, body);
}

export async function getUsers(params) {
  return api.get(`/people`, { params: params });
}

export async function deleteUser(id) {
  return api.delete(`/people/${id}`);
}

export async function getDashboard(params) {
  return api.get(`/people/dashboard`, { params: params });
}

export async function getAttendancesGraph(params) {
  return api.get(`/people/dashboard/graph`, { params: params });
}
export async function getAttendancesAwaitingGraph(params) {
  return api.get(`/people/dashboard/attendance-awaiting-time/counts`, {
    params: params,
  });
}

export async function getAttendancesGiveupGraph(params) {
  return api.get(`/people/dashboard/attendance-give-up-time/counts`, {
    params: params,
  });
}

export async function getTimeAttendanceGraph(params) {
  return api.get(`/people/dashboard/average-time-attendance/graph`, {
    params: params,
  });
}

export async function getReportsRating(params) {
  return api.get(`/attendances/reports/rating`, { params: params });
}

export async function getPermissionGroups(params) {
  return api.get(`/permission-groups`, { params: params });
}

export async function isLinkedPeople(personID, params) {
  return await api.get(`/people/${personID}/have-associations`, {
    params: params,
  });
}

export async function getStatusAnalytics(params) {
  return api.get(`/people/status/analytics`, { params: params });
}

export async function getDeskStatus(params) {
  return api.get(`/people/status/desks`, { params: params });
}

export async function getGiveUpConsolidatedReport(params) {
  return api.get(
    `/people/dashboard/attendance-give-up-consolidated-time/counts`,
    {
      params: params,
    }
  );
}

/**
 * Devolve pessoas ao limite padrão do tribunal, removendo o limite individual.
 * Sem `personIDs`, atinge todas as que hoje têm exceção. Ver ADR-008.
 */
export async function resetAttendanceLimits(payload = {}) {
  return api.put(`/people/attendance-limits/reset`, payload);
}
